import { render, staticRenderFns } from "./ReportDifficultQuestions.vue?vue&type=template&id=7ec96cfa"
import script from "./ReportDifficultQuestions.vue?vue&type=script&lang=js"
export * from "./ReportDifficultQuestions.vue?vue&type=script&lang=js"
import style0 from "./ReportDifficultQuestions.vue?vue&type=style&index=0&id=7ec96cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports